import { quotes } from "@/mocks/gossip";

const statData = [
  { icon: "ri-thumb-up-line", value: "126w+", label: "吃瓜爱好者在线" },
  { icon: "ri-article-line", value: "3.2w+", label: "累计解锁瓜料" },
  { icon: "ri-time-line", value: "99.9%", label: "热点跟进及时率" },
  { icon: "ri-money-cny-circle-line", value: "0 元", label: "永久免费畅享" },
];

const avatarColor = ["bg-primary-200 text-primary-800", "bg-accent-200 text-accent-800", "bg-secondary-200 text-secondary-800"];

export default function Praise() {
  return (
    <section id="praise" className="scroll-mt-20 bg-background-100/70 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="rounded-lg bg-gradient-to-r from-primary-500 to-primary-600 px-6 py-8 md:px-10">
          <div className="grid grid-cols-2 gap-6 text-center lg:grid-cols-4">
            {statData.map((s) => (
              <div key={s.label}>
                <span className="mx-auto flex h-10 w-10 items-center justify-center rounded-full bg-white/15 text-background-50">
                  <i className={`${s.icon} text-xl`} />
                </span>
                <p className="font-heading mt-3 text-2xl font-bold text-white md:text-3xl">{s.value}</p>
                <p className="mt-1 text-xs text-white/80 md:text-sm">{s.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 lg:grid-cols-3">
          {quotes.map((q, i) => (
            <figure
              key={q.name}
              className="flex flex-col rounded-lg border border-background-200/70 bg-background-50 p-5"
            >
              <i className="ri-double-quotes-l text-2xl text-secondary-300" />
              <blockquote className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700">
                “{q.text}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200/70 pt-4">
                <span className={`flex h-9 w-9 items-center justify-center rounded-full text-sm font-bold ${avatarColor[i % 3]}`}>
                  {q.name.slice(0, 1)}
                </span>
                <span>
                  <span className="block text-sm font-semibold text-foreground-900">{q.name}</span>
                  <span className="block text-xs text-foreground-400">{q.role}</span>
                </span>
                <i className="ri-star-fill ml-auto text-sm text-secondary-400" />
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}